import font_path from "../fonts/font.ttf"
import { HorizontalAlign } from "../types/align/HorizontalAlign"
import { VerticalAlign } from "../types/align/VerticalAlign"
import type { PlottingContext } from "../types/options/PlottingContext"

export function CreateContext(
  context: PlottingContext
): Required<PlottingContext> {
  return {
    color_map: {},
    file_map: {},
    scale_map: {},
    unit_to_px: 1,
    page_bleed: 0,
    scale_bleed: 0,
    stroke_width: 1,
    font_path,
    font_size: 12,
    font_height_adjustment: 0.61,
    font_family: "Helvetica",
    vertical_align: VerticalAlign.CENTER,
    horizontal_align: HorizontalAlign.CENTER,
    image_resolution: 300,
    ...context,
  }
}
